"use client";

import { Button, Icon, Text } from "@focal/ui-kit";
import AvatarComponent from "@/components/common/AvatarCustom/AvatarCustom";
import { Participant } from "@/types";
import {
  getParticipantEmail,
  getParticipantName,
} from "@/lib/participant-utils";

interface ParticipantChipProps {
  participant: Partial<Participant>;
  onRemove: (participantId: string) => void;
  disabled?: boolean;
}

export const ParticipantChip = ({
  participant,
  onRemove,
  disabled,
}: ParticipantChipProps) => {
  const name = getParticipantName(participant);
  const email = getParticipantEmail(participant);

  const handleRemove = () => {
    if (!participant.id) return;
    onRemove(participant.id);
  };

  return (
    <div
      className="group flex items-center gap-1 rounded-xl p-1 text-left hover:bg-actions-hover transition-colors min-w-0"
      data-cy="pre-meeting-participant-chip"
    >
      <AvatarComponent
        name={name || email}
        className="w-6 h-6 rounded-full text-xs shrink-0 cursor-default"
      />
      <div className="min-w-0 flex-1">
        <Text variant="p3" className="truncate min-w-0">
          {name || email}
        </Text>
        {name && email ? (
          <Text variant="p3" textColor="secondary" className="truncate min-w-0">
            {email}
          </Text>
        ) : null}
      </div>
      {!disabled && (
        <Button
          type="button"
          variant="ghostSecondary"
          size="iconSm"
          aria-label="Remove participant"
          className="opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity shrink-0"
          data-cy="pre-meeting-participant-remove"
          onClick={handleRemove}
        >
          <Icon name="CloseIcon" size="sm" />
        </Button>
      )}
    </div>
  );
};
